import React from 'react'
import SubHeader from '../../../layout/components/SubHeader'
import {toAbsoluteUrl} from '../../../helpers/AssetHelpers'
import ReminderCard from './tabcards/ReminderCard'

function ReminderSettings() {
  return (
    <>
       <SubHeader title="Clinic Reminders" description={"Manage your clinic's reminder preferences and notification settings."}/>
       <div className="row mt-3">
        <div className="col-3">
        <img src={toAbsoluteUrl('/media/illustrations/ecx/reminder_ustg.svg')} className='img-fluid p-5' />
        </div>
        <div className="col-9">
           <ReminderCard />
        </div>
    </div>
    </>
  )
}

export default ReminderSettings